import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const UpdateHolidays = async (FormData, HolidaysID) => {
  try {
    const HolidayDocument = doc(db, "Holidays", HolidaysID);

    const data = {
      ...FormData,
      ...HelperForMetaData({}),
    };

    delete data.createdAt;
    delete data.createdBy;

    await updateDoc(HolidayDocument, data);

    return true;
  } catch (error) {
    console.log(error);

    return false;
  }
};

export default UpdateHolidays;
